import {Icon, NavigationButton} from '@hm/fundamental'
import {mdiCog} from '@mdi/js'
import {useTranslation} from 'react-i18next'

interface CustomizeMenuButtonProps {
  onClick: () => void
}

export const CustomizeMenuButton: React.FC<CustomizeMenuButtonProps> = ({onClick}) => {
  const {t} = useTranslation()

  return (
    <div className="flex px-6 pt-2">
      <NavigationButton
        onClick={onClick}
        className="rounded-md flex-1"
        data-cy="customize_menu_button"
        icon={<Icon path={mdiCog} />}
        style={{height: '48px'}}
      >
        <span>{t('suite.header.customizeMenu')}</span>
      </NavigationButton>
    </div>
  )
}
